import React, { useEffect, useState } from "react"
import { IconButton, Grid } from "@material-ui/core"
import moment from "moment"
import EditTaggedDateIcon from "../icons/EditTaggedDateIcon"
import { useDispatch, useSelector } from "react-redux"
import { TAGGED_DATE_FORMAT } from "../../utils"

function TaggedDate(props) {
	return (
		<Grid container spacing={1}>
			<Grid item xs={8}>
				{moment.utc(props?.data?.tagged_date).local().format(TAGGED_DATE_FORMAT)}
			</Grid>
			<Grid item xs={4}>
				<IconButton
					onClick={() => {
						props?.dialogData?.setTaggedDateDialogOpen(true)
						props?.dialogData?.setTagDatedDialogData({ ...props?.data, tagged_date: props?.data?.tagged_date })
					}}
				>
					<EditTaggedDateIcon />
				</IconButton>
			</Grid>
		</Grid>
	)
}

export default TaggedDate
